import { useEffect, useState } from 'react';

import { getFreeProducts } from '../api/getFreeProducts';
import { getProducts } from '../api/getProducts';
import { ProductCodes } from '../pages/types';

export function useProductsByCountry(countryCode?: string, opts?: { includePaid?: boolean }) {
  const [freeProducts, setFreeProducts] = useState<ProductCodes[]>([]);
  const [products, setProducts] = useState<ProductCodes[]>([]);

  useEffect(() => {
    if (!countryCode) return;

    getFreeProducts(countryCode).then((res) => setFreeProducts(res.data));

    if (opts?.includePaid) {
      getProducts(countryCode).then((res) => setProducts(res.data));
    } else {
      setProducts([]);
    }
  }, [countryCode, opts?.includePaid]);

  return { freeProducts, products };
}
